module.exports = __webpack_public_path__ + "img/italic.92a1af7a.svg";